import React, { useCallback, useEffect, useState } from "react";
import { Table, Button, Modal } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import "./LicenseInfoTable.css";

const LicenseInfoTable = ({
  agentLicenseInfo,
  onEditClick,
  onDeleteLicense,
  type,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [proceed, setProceed] = useState(false);
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");

  const sanitizeText = (text) => {
    if (!text || typeof text !== "string") return text || "";
    return text.replace(/[<>]/g, "");
  };

  const baseColumns = [
    { field: "licenseNumber", header: "License Number", width: "150px" },
    { field: "stateId", header: "State", width: "100px" },
    { field: "expiryDate", header: "Expiry Date", width: "120px" },
    { field: "afftCompanyName", header: "Company Name", width: "140px" },
    {
      field: "officeAddress",
      header: "Licensed State Office Address",
      width: "120px",
    },
  ];

  const actionCol = [
    {
      field: "actions",
      header: "Actions",
      width: "100px",
      render: (row) => {
        const licenseId = sanitizeText(row.licenseId || row.agentLicenseId);
        const licenseLabel = sanitizeText(
          row.licenseNumber || row.agentLicenseId
        );
        return (
          <div className="action-buttons">
            <Button
              onClick={() => onEditClick(row, type)}
              variant="outlined"
              aria-label={`Edit license ${licenseLabel}`}
            >
              <FaEdit />
            </Button>
            <Button
              onClick={() => handleDelete(licenseId)}
              variant="outlined"
              aria-label={`Delete license ${licenseLabel}`}
            >
              <FaTrash />
            </Button>
          </div>
        );
      },
    },
  ];

  const columns =
    type === "Indv"
      ? [
          ...baseColumns,
          { field: "status", header: "Status", width: "100px" },
          ...actionCol,
        ]
      : [...baseColumns, ...actionCol, { field: "", header: "", width: "0px" }];

  const handleDelete = useCallback((licenseId) => {
    setShow(true);
    setId(licenseId);
  }, []);

  useEffect(() => {
    if (proceed && id) {
      deleteLicense(id);
    }
  }, [proceed, id, onDeleteLicense]);

  const deleteLicense = (licenseId) => {
    onDeleteLicense(licenseId);
    setShow(false);
    setProceed(false);
  };

  return (
    <>
      <div className="table-responsive">
        <table className="license-table">
          <thead>
            <tr>
              {columns.map(
                (column) =>
                  column.header ? (
                    <th key={column.field} style={{ width: column.width }}>
                      {column.header}
                    </th>
                  ) : null
                // <th
                //   key={column.field}
                //   style={{
                //     width: column.width,
                //   }}

                // >
                //   {column.header}
                // </th>
              )}
            </tr>
          </thead>

          <tbody>
            {agentLicenseInfo?.map((license) => (
              <tr key={license.licenseId}>
                {columns.map((column) => {
                  if (column.field === "licenseNumber") {
                    return (
                      <td
                        style={{
                          width: column.width,
                          paddingLeft: `${type === "Indv" ? "12px" : "10px"}`,
                        }}
                      >
                        {sanitizeText(license.licenseNumber) || "-"}
                      </td>
                    );
                  } else if (column.field === "stateId") {
                    return (
                      <td
                        style={{
                          width: column.width,
                          paddingLeft: `${type === "Indv" ? "12px" : "10px"}`,
                        }}
                      >
                        {sanitizeText(
                          license.stateId || license?.stateDto?.stateId
                        ) || "-"}
                      </td>
                    );
                  } else if (column.field === "expiryDate") {
                    return (
                      <td
                        style={{
                          width: column.width,
                          paddingLeft: `${type === "Indv" ? "12px" : "10px"}`,
                        }}
                      >
                        {sanitizeText(
                          license.licenseExpiryDate || license?.expiryDate
                        ) || "-"}
                      </td>
                    );
                  } else if (column.field === "afftCompanyName") {
                    const val =
                      sanitizeText(
                        license.afftCompanyName || license?.company
                      ) || "-";
                    return (
                      <td
                        style={{
                          width: column.width,
                          paddingLeft: `${type === "Indv" ? "12px" : "10px"}`,
                        }}
                      >
                        {val.length > 22 ? val.slice(0, 22) + "..." : val}
                      </td>
                    );
                  } else if (column.field === "officeAddress") {
                    return (
                      <td
                        style={{
                          width: column.width,
                          paddingLeft: `${type === "Indv" ? "12px" : "10px"}`,
                        }}
                      >
                        {license?.address1} {license?.address2} {license?.city}
                        {license?.state ? <>,{license?.state}</> : ""}
                        {license?.zip ? <>,{license?.zip}</> : ""}
                      </td>
                    );
                  } else if (column.field === "status" && type === "Indv") {
                    return (
                      <td
                        style={{
                          width: column.width,
                          paddingLeft: `${type === "Indv" ? "12px" : "10px"}`,
                        }}
                      >
                        {license.status === "LCNS_PEND"
                          ? "Pending"
                          : license.status === "LCNS_RJCT"
                          ? "Rejected"
                          : license.status === "LCNS_SUSP"
                          ? "Suspended"
                          : "Approved"}
                      </td>
                    );
                  } else if (column.field === "actions") {
                    return (
                      <td
                        style={{
                          width: column.width,
                          paddingLeft: `${type === "Indv" ? "12px" : "10px"}`,
                        }}
                      >
                        {column.render(license)}
                      </td>
                    );
                  } else {
                    return null;
                  }
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton className="license-title">
          Delete License
        </Modal.Header>
        <Modal.Body>
          <p className="text-center mt-4">
            Are you sure to delete the license?
          </p>
        </Modal.Body>
        <Modal.Footer className="text-center justify-content-center">
          <button
            onClick={() => setProceed(true)}
            className="license-delete-btn-yes"
          >
            Yes
          </button>
          <button
            onClick={() => {
              setProceed(false);
              setShow(false);
            }}
            className="license-delete-btn"
          >
            No
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LicenseInfoTable;
